var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import logoImage from '../assets/logo.png';
var Login = function () {
    var _a = useState(''), username = _a[0], setUsername = _a[1];
    var _b = useState(''), password = _b[0], setPassword = _b[1];
    var _c = useState(false), showPassword = _c[0], setShowPassword = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(''), error = _e[0], setError = _e[1];
    var login = useAuth().login;
    var navigate = useNavigate();
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var success, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setError('');
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, login(username, password)];
                case 2:
                    success = _a.sent();
                    if (success) {
                        navigate('/dashboard');
                    }
                    else {
                        setError('Invalid username or password');
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    setError('Login failed. Please try again.');
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", __assign({ className: "login-container" }, { children: _jsxs("div", __assign({ className: "login-card" }, { children: [_jsxs("div", __assign({ className: "login-header" }, { children: [_jsx("div", __assign({ className: "logo-container" }, { children: _jsx("img", { src: logoImage, alt: "CPD Logo", className: "logo", onError: function (e) {
                                    var target = e.target;
                                    target.src = "/logo_192x192.png";
                                } }) })), _jsx("h1", { children: "Welcome Back" }), _jsx("p", { children: "Sign in to your CPD account" })] })), _jsxs("form", __assign({ onSubmit: handleSubmit, className: "login-form" }, { children: [error && (_jsx("div", __assign({ className: "error-message" }, { children: error }))), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ htmlFor: "username" }, { children: "Username" })), _jsx("input", { type: "text", id: "username", value: username, onChange: function (e) { return setUsername(e.target.value); }, placeholder: "Enter your username", required: true, disabled: isLoading })] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ htmlFor: "password" }, { children: "Password" })), _jsxs("div", __assign({ className: "password-wrapper" }, { children: [_jsx("input", { type: showPassword ? 'text' : 'password', id: "password", value: password, onChange: function (e) { return setPassword(e.target.value); }, placeholder: "Enter your password", required: true, disabled: isLoading }), _jsx("button", __assign({ type: "button", className: "password-toggle", "aria-label": showPassword ? 'Hide password' : 'Show password', onClick: function () { return setShowPassword(!showPassword); }, tabIndex: -1 }, { children: _jsx("i", { className: "pi ".concat(showPassword ? 'pi-eye-slash' : 'pi-eye'), "aria-hidden": "true" }) }))] }))] })), _jsx("button", __assign({ type: "submit", className: "login-button", disabled: isLoading }, { children: isLoading ? (_jsxs("div", __assign({ className: "loading-spinner" }, { children: [_jsx("div", { className: "spinner" }), "Signing in..."] }))) : ('Sign In') }))] })), _jsx("div", __assign({ className: "login-footer" }, { children: _jsxs("p", { children: ["\u00A9 ", new Date().getFullYear(), " CPD. All rights reserved."] }) }))] })) })));
};
export default Login;
